import { getBetDescription } from '../../data/utils/getBetDescription';

export function getGroupBetDescription(bet) {
    let desc = null;
    if (bet.handicap != null) {
        if (bet.descNoHandicap) {
            desc = bet.descNoHandicap;
        } else {
            desc = bet.desc;
        }

        if (desc.includes('@@')) {
            desc = desc.replaceAll('@@H1@@', 'X')
               .replaceAll('@@H2@@', 'Y')
               .replaceAll('@@H3@@', 'Z')
               .replaceAll('@@H4@@', 'K');
        }
        if (desc.includes('{{')) {
            desc = desc.replaceAll('{{H1}}', 'X')
                    .replaceAll('{{H2}}', 'Y')
                    .replaceAll('{{H3}}', 'Z')
                    .replaceAll('{{H4}}', 'K');
        }

        return desc;
    }

    return getBetDescription(bet, true);
}
